const GradientBar = ({ percent, invert = false }) => {
  const wrapperStyle = {
    position: "relative",
    width: "396px",
    height: 37,
    marginTop: 40,
  };

  const gradient = invert
    ? "linear-gradient(90deg, #3ACC31, #fed330, #ff5733)"
    : "linear-gradient(90deg, #ff5733, #fed330, #3ACC31)";

  const barStyle = {
    width: "100%",
    height: "100%",
    borderRadius: 2,
    background: gradient,
  };

  const markerStyle = {
    position: "absolute",
    left: `${percent}%`,
    top: -10,
    width: 9,
    height: 55,
    background: "#000",
    borderRadius: 2,
    transform: "translateX(-50%)",
  };

  const labelStyle = {
    position: "absolute",
    left: `${percent}%`,
    top: -39,
    transform: "translateX(-50%)",
    background: "#fff",
    padding: "4px 8px",
    fontSize: 15,
    fontWeight: "bold",
    whiteSpace: "nowrap",
  };

  const rangeLabelsStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15,
    marginLeft: 8,
    fontSize: 18,
    fontWeight: "bold",
    color: "#333",
    width: "396px",
    letterSpacing: "1.5px",
  };

  return (
    <div>
      <div style={wrapperStyle}>
        <div style={barStyle} />
        <div style={markerStyle} />
        <div style={labelStyle}>{percent}%</div>
      </div>

      <div style={rangeLabelsStyle}>
        <span>Bajo</span>
        <span>Medio</span>
        <span>Alto</span>
      </div>
    </div>
  );
};

export default GradientBar;
